import { Reveal, Overline } from "@/components/Reveal";
import { useLang } from "@/i18n";

const ABOUT_IMG = "https://images.unsplash.com/photo-1648634158203-199accfd7afc?auto=format&fit=crop&w=1200&q=80";

export default function About() {
  const { t } = useLang();
  return (
    <section id="chi-siamo" data-testid="about-section" className="bg-ivory py-28 md:py-40">
      <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-16 px-6 lg:grid-cols-12 lg:gap-12 lg:px-12">
        <div className="lg:col-span-5">
          <Reveal>
            <Overline>{t.about.overline}</Overline>
            <h2 className="font-serif text-4xl font-light leading-[1.08] tracking-tight text-navy md:text-5xl lg:text-6xl">
              {t.about.title}
            </h2>
            <p className="mt-8 max-w-md text-base font-light leading-relaxed text-navy/70 md:text-lg">
              {t.about.text}
            </p>
            <p className="mt-5 max-w-md text-sm font-light leading-relaxed text-navy/55">
              {t.about.text2}
            </p>
          </Reveal>
          <Reveal delay={0.15} className="mt-14 hidden lg:block">
            <div className="relative max-w-sm">
              <div className="absolute -left-4 -top-4 h-full w-full border border-champagne/50" />
              <div className="group relative overflow-hidden">
                <img
                  src={ABOUT_IMG}
                  alt="Interno elegante curato da Élite Service"
                  loading="lazy"
                  className="aspect-[4/5] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                />
              </div>
              <p className="mt-4 font-serif text-sm italic text-navy/50">{t.about.imageCaption}</p>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7 lg:pt-24">
          {(t.about.chapters || []).map((c, i) => (
            <Reveal key={c.num} delay={i * 0.08}>
              <div data-testid={`about-chapter-${c.num}`} className="group flex gap-8 border-b border-champagne/20 py-10 transition-colors duration-500 first:border-t md:gap-14 md:py-12">
                <span className="font-serif text-5xl font-light leading-none text-champagne/80 transition-colors duration-500 group-hover:text-champagne md:text-7xl">
                  {c.num}
                </span>
                <div>
                  <h3 className="font-serif text-2xl font-light tracking-tight text-navy md:text-3xl">{c.title}</h3>
                  <p className="mt-3 max-w-lg text-sm font-light leading-relaxed text-navy/65 md:text-base">{c.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
